<widget-business-indicators-advancement [businessIndicatorId]="config.businessIndicatorId" [isEstimated]="config.isEstimated" [classificationNodeId]="classificationNodeId()" [title]="config.title" [displayLegend]="config.displayLegend" />
